import { useState } from 'react'

/**
 * useAlert Hook - Custom hook for alert management with auto-dismiss
 * 
 * @param {Object} options - Configuration options
 * @param {number} options.defaultAutoDismissMs - Default auto-dismiss time in milliseconds
 * @returns {Object} Alert state and methods
 */
const useAlert = ({ defaultAutoDismissMs = 5000 } = {}) => {
  const [alertMessage, setAlertMessage] = useState('')
  const [alertType, setAlertType] = useState('')
  const [alertTitle, setAlertTitle] = useState('')

  const showAlert = (message, type = 'success', options = {}) => {
    const { 
      autoDismissMs = defaultAutoDismissMs, 
      title = '', 
    } = options
    
    setAlertMessage(message)
    setAlertType(type)
    setAlertTitle(title)
    
    if (autoDismissMs > 0) {
      setTimeout(() => {
        clearAlert()
      }, autoDismissMs)
    }
  }

  const clearAlert = () => {
    setAlertMessage('')
    setAlertType('')
    setAlertTitle('')
  }

  const isVisible = Boolean(alertMessage)

  return { 
    alertMessage, 
    alertType, 
    alertTitle,
    isVisible,
    showAlert, 
    clearAlert, 
  }
}

export default useAlert
